
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Construction & Génie Civil',
      description: 'Construction de bâtiments résidentiels, commerciaux, industriels, travaux de génie civil, routes, ponts et maisons préfabriquées.',
      color: 'bg-orange-100 text-orange-600'
    },
    {
      icon: 'ri-stack-line',
      title: 'Matériaux de Construction',
      description: 'Traitement et vente de matériaux : moellons, sable, gravier, blocs-ciments, ciment, briques, tôles, pavés, colonnes, plafonds, chaux, peintures, clous.',
      color: 'bg-teal-100 text-teal-600'
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Carrelage & Revêtements',
      description: 'Travaux de carrelage pour sols, murs, cuisines, salles de bain et espaces extérieurs avec finitions professionnelles.',
      color: 'bg-amber-100 text-amber-600'
    }
  ];

  return (
    <section id="services" className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            Nos <span className="text-blue-600">Services</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            Des solutions complètes pour tous vos projets de construction et d'entretien
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:-translate-y-1"
            >
              <div className={`w-14 h-14 sm:w-16 sm:h-16 ${service.color} rounded-xl flex items-center justify-center mb-4 sm:mb-6`}>
                <i className={`${service.icon} text-2xl sm:text-3xl`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">{service.title}</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a 
            href="/services"
            className="inline-block bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-full hover:from-blue-700 hover:to-blue-800 transition-all duration-300 font-medium cursor-pointer whitespace-nowrap shadow-md hover:shadow-lg transform hover:-translate-y-0.5 text-sm sm:text-base"
          >
            Voir tous nos services
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
